import gql from 'graphql-tag'

export const COMMISSION_LIST_START_PROCESSING_MUTATION = gql`
    mutation commissionListStartProcessing(
        $id: ID!
    ) {
        commissionListStartProcessing(
            id: $id
        ) {
            id
            status
        }
    }
`
